import React, {useState,useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import authService from 'core/services/authService';

const defaults = {
  isUserLoggedIn: false,
  authToken: null,
  userId: null,
  data: {}
};
function readAuthDataFromLocalStorage() {
  try{
    if(window.localStorage.getItem("rpgmUserInfo")){
      const storedData = JSON.parse(window.localStorage.getItem("rpgmUserInfo"));
      authService.setAuthToken(storedData?.authToken || null);
      return {
        ...defaults,
        ...storedData
      }
    } else {
      authService.setAuthToken(defaults?.authToken || null);
      return defaults;
    }
  } catch(e) {
    return defaults;
  }
}

const AuthContext = React.createContext({...readAuthDataFromLocalStorage()});

const AuthContextProvider = (props) => {
  const [context, setContext] = useState({...readAuthDataFromLocalStorage()});
  let navigate = useNavigate();
  useEffect(() => {
    authService.setAuthToken(context?.authToken || null);
  }, [context]);

  const updateAuthContext = ( contextValues = {}) => {
    const data = {
      ...context,
      ...contextValues
    }
    window.localStorage.setItem("rpgmUserInfo", JSON.stringify(data));
    setContext(data);
  }

  const userSignout = () => {
    setContext({...defaults});
    window.localStorage.setItem("rpgmUserInfo", JSON.stringify(defaults));
    navigate('/signin/', {replace: true});
  }

  return (
    <AuthContext.Provider value={{...context, updateAuthContext, userSignout}}>
      {props.children}
    </AuthContext.Provider>
  );
}
 
export default AuthContextProvider;
export { AuthContext };
